import React from 'react';
import { Helmet } from 'react-helmet-async';
import TituloContacto from '../components/sections/Contacto/TituloContacto'; 
import DireccionFormulario from '../components/sections/Contacto/DireccionFormulario';
import TituloGracias from '../components/sections/Gracias/TituloGracias';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const ContactoDecototal = () => {
  return (
    <div>
      <Helmet>
        <title>Contacto | Decototal</title>
         <meta name="description" content="Página de contacto para Decototal. Escríbenos y obtén información personalizada." />
         <meta name="keywords" content="Contacto, Cotización Deco Total, Decototal, Pisos" />
         <link rel="canonical" href="https://decototal.com.mx/contacto-decototal" />
         <meta property="og:title" content="Contacto Decototal" />
         <meta property="og:description" content="Página de contacto para Decototal. Escríbenos y obtén información personalizada." />
         <meta property="og:image" content="URL-de-tu-imagen.jpg" />
         <meta property="og:url" content="https://decototal.com.mx/contacto-decototal" />
      </Helmet>

      <Header />
        <TituloContacto /> 
        <DireccionFormulario /> 
        <TituloGracias /> 
      <Footer />
    </div>
  );
};

export default ContactoDecototal;